import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { refreshFrameUrl } from "./dashcamScan";

/**
 * A probed frame. Its presigned link lives 60 s, so a load failure re-reads the operation once for a
 * fresh link instead of capturing again.
 */
export default function ProbeFrame({ url, operationId, alt }) {
  const [src, setSrc] = useState(url);
  const retried = useRef(false);
  const mounted = useRef(true);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
  useEffect(() => {
    setSrc(url);
    retried.current = false;
  }, [url]);

  const handleError = async () => {
    if (retried.current || !operationId) return;
    retried.current = true;
    const fresh = await refreshFrameUrl(operationId);
    if (fresh && mounted.current) setSrc(fresh);
  };

  return <img src={src} alt={alt} style={{ width: "100%" }} onError={handleError} />;
}

ProbeFrame.propTypes = {
  url: PropTypes.string.isRequired,
  operationId: PropTypes.string,
  alt: PropTypes.string.isRequired,
};

ProbeFrame.defaultProps = {
  operationId: null,
};
